var _defs, _circle, _path, _path2, _path3, _path4, _circle2, _path5, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAquarium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE6FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "water",
    x1: 13,
    x2: 51,
    y1: 21,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0284C7"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F172A",
    d: "M12 16h40v6H12zM12 50h40v6H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#water)",
    d: "M14 22h36v28H14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F97316",
    d: "M24 34c5-6 13-6 18 0-5 6-13 6-18 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB923C",
    d: "m42 34 7-5v10l-7-5Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 33,
    r: 1.3,
    fill: "#1F2937"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#22C55E",
    d: "M20 48c-3-7-1-13 4-18 3 8 2 14-4 18ZM44 48c-4-6-3-12 2-17 3 7 3 13-2 17Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 22,
    r: 2,
    fill: "#E0F2FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 28,
    r: 1.6,
    fill: "#E0F2FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquarium);
export default __webpack_public_path__ + "static/media/aquarium.a27128a0db60cb5fc29ccac071d800fc.svg";
export { ForwardRef as ReactComponent };